import { formatToCpfUsername } from 'utils/format';
import { isCpf } from 'utils/validation';

export function mapMemberToPersonalInfoValues(member) {
  const { user } = member;
  const document = user?.document || '';

  return {
    photo: user?.photo || '',
    photoFile: undefined,
    username: isCpf(document) ? formatToCpfUsername(document) : document,
    firstName: user?.first_name || '',
    lastName: user?.last_name || '',
    birthYear: user?.birth_date ? user.birth_date.split('-')[0] : '',
  };
}

export function validatePersonalInfo(values, messages) {
  const { firstName, lastName } = values;
  const errors = new Map();

  if (!firstName) {
    errors.set('firstName', messages.FILL_REQUIRED);
  }

  if (!lastName) {
    errors.set('lastName', messages.FILL_REQUIRED);
  }

  return errors;
}

export function buildPersonalInfoFormData(values) {
  const { firstName, lastName, birthYear, photoFile } = values;
  const formData = new FormData();

  formData.append('first_name', firstName);
  formData.append('last_name', lastName);

  if (photoFile !== undefined) {
    formData.append('photo', photoFile);
  }

  if (birthYear) {
    formData.append('birth_date', `${birthYear}-01-01`);
  }

  return formData;
}
